import { Button } from '@mui/material'
import { useCallback } from 'react'

import { PhxIcon } from '@salsita-ai/platform-project-sdk/ui'

import { MetalworksAnalytics, analyticsService } from '../../systems/analytics'

interface ReturnButtonProps {
  returnUrl: string
}

export const ReturnButton = (props: ReturnButtonProps) => {
  const { returnUrl } = props

  const handleReturn = useCallback(async () => {
    analyticsService.push(MetalworksAnalytics.ReturnToDavewebButtonClicked())
    location.href = returnUrl
  }, [returnUrl])

  return (
    <Button startIcon={<PhxIcon name="ShoppingCartSimple" />} variant="contained" onClick={handleReturn}>
      View Quote in Daveweb
    </Button>
  )
}
